var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.984,
    height: 22.938,
    viewBox: "0 0 22.984 22.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4669.886 -16014.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.346,57.357H1.307L4.949,42.419H18.13Z",
    transform: "translate(-4670.238 15979.081)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.039,5.785V4.6a3.6,3.6,0,0,1,3.6-3.6h2.811a3.6,3.6,0,0,1,3.6,3.6v1.19",
    transform: "translate(-4707.488 16014)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.3de4ed97f57c081045c61c264b2e8788.svg";
export { ForwardRef as ReactComponent };